<template>
    <div class="xcard">
        <h4 class="text-center mb-6" style="margin-top:0"> Inscripciones de la feria </h4>
        <div class="row">
            <div class="col-xs-3">
                <v-text-field v-model="desde" type="date" dense label="desde:"/>
            </div>
            <div class="col-xs-3">
                <v-text-field v-model="hasta" type="date" dense label="hasta:"/>
            </div>
            <div class="col-xs-2">
                <v-select label="Canal:" dense :loading="loading" :items="canales" v-model="canal" return-object/>
            </div>
            <div class="col-xs-2">
                <v-btn tile color="orange darken-2" :loading="loading" small dark @click="cargarDatos()">filtrar</v-btn>
            </div>
            <div class="col-xs-2 text-right" >
                <v-btn tile color="cyan darken-3" style="color:white" small @click="openReporteF()">Reportes </v-btn>
            </div>
        </div>
        <hr /> 
        <v-data-table dense :headers="headers" :loading="loading" :items="datos" :items-per-page="500" disable-pagination hide-default-footer class="elevation-1">
            <template v-slot:[`item.asesor`]="{ item }">
                <span> {{ item.asesor.nombres }} {{ item.asesor.pri_apellido }} {{ item.asesor.seg_apellido }}</span>
            </template>
            <template v-slot:[`item.canal`]="{ item }">
                <span> {{ item.canal.nombre }} </span>
            </template>
            <template v-slot:[`item.estado_inscripcion_id`]="{ item }">
                <span> {{ getEstadoStr(item.estado_inscripcion_id) }} </span>
            </template>
            <template v-slot:[`item.estudiante`]="{ item }">
                <span> {{ item.estudiante.nombres }} {{ item.estudiante.pri_apellido }} {{ item.estudiante.seg_apellido }} </span>
            </template>
            <template v-slot:[`item.programa`]="{ item }">
                <span> {{ item.programa.postgrado.nombre }} </span>
            </template>
            <template v-slot:[`item.pagos`]="{ item }">
                <div v-html="getPlanPagos(item.plan_pagos)"> </div>
            </template>
            <template v-slot:[`item.sede`]="{ item }">
                <span> {{ item.programa.sede.nombre }} </span>
            </template>
        </v-data-table>

        <ReportFeria ref="refReportFeria" />
    </div>
</template>


<script>
import ReportFeria from '@/components/reportes_feria/ins/xreporteinsm.vue'
import gql from "graphql-tag";

export default {
    components: { ReportFeria },
    data() {
        return {
            loading: false,
            desde:null,
            hasta: null,
            datos:[],
            headers: [
                { text: 'Asesor', value: 'asesor' },
                { text: 'canal', value: 'canal' },
                { text: 'estado', value: 'estado_inscripcion_id' },
                { text: 'estudiante', value: 'estudiante' },
                { text: 'programa', value: 'programa' },
                { text: 'pagos: cuotas pagado / total', value: 'pagos' },
                { text: 'sede', value: 'sede' },
            ],
            canales:[
                {id:1, text:'FEXPO CRUZ'},
                {id:9, text:'FEXPO SUCRE'},
                {id:10, text:'EXPOSUR'},
            ],
            canal: null,
        };
    },
    watch: {
    }, 
    methods: {
        getCurrentMonthDates() {
            const now = new Date();
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            const formatDate = (date) => date.toISOString().split('T')[0];
            this.desde = formatDate(firstDay);
            this.hasta = formatDate(lastDay); 
        },
        getEstadoStr(estado_ins){
            let ma = {
                0:'?',
                1:'PROSPECTO',
                2:'PREINSCRITO',
                3:'INSCRITO',
                4:'RETIRADO',
            }
            return ma[estado_ins]
        },
        getPlanPagos(plan){ 
            // Agrupar por concepto
            const agrupados = plan.reduce((acc, item) => {
                const concepto = item.concepto_pago.nombre;
                const montoPagado = item.monto - item.saldo;
                
                if (!acc[concepto]) {
                    acc[concepto] = {
                        cantidad: 0,
                        montoPagado: 0,
                        montoTotal: 0,
                        pagados: []
                    };
                }
                
                acc[concepto].cantidad += 1;
                acc[concepto].montoPagado += montoPagado;
                acc[concepto].montoTotal += item.monto;
                if(montoPagado>0){
                    acc[concepto].pagados.push(item)
                }
                
                return acc;
            }, {});

            const resultado = Object.entries(agrupados).map(([concepto, valores]) => {
                let a = `<small> <p class="mb-0"> <b>${concepto}:</b> ${valores.cantidad} ${valores.montoPagado}bs / ${valores.montoTotal}bs </p> </small>`;
                valores.pagados.forEach(p=>{
                    a += `<small> <p class="my-0 ml-10 blue--text"> <b>|cuota ${p.nro_cuota}:</b> ${p.monto-p.saldo}bs  </p> </small>`
                })
                return a;
            });

            // window.console.log('---->',agrupados);
            // window.console.log('---->',resultado.join(' '));
            return resultado.join(' ');
        },
        async cargarDatos(){
            this.loading = true;
            this.datos = [];
            let canal_id = this.canal.id;
            window.console.log('-*-', canal_id);
            
            let pp = `plan_pagos{ id monto saldo nro_cuota descuento fecha_pago concepto_pago{ id nombre } }`
            let sql = gql` query { getInscripcionesCanalId(canalId: ${canal_id}, fechas: {fecha_ini: "${this.desde}", fecha_fin: "${this.hasta}"}) { id estado_ins estado_inscripcion_id fecha_registro estudiante{id nombres pri_apellido seg_apellido} programa { id sede {id nombre} postgrado { id nombre categoria { id nombre } } } asesor { id nombres pri_apellido seg_apellido } canal { id nombre } ${pp} } } `;
            let res = await this.$apollo.query({query: sql}).then(({data})=>data).catch(e=>e)
            // window.console.log('res',res);
            if(res && res.getInscripcionesCanalId){
                this.datos = res.getInscripcionesCanalId;
            }
            this.loading = false;
        },
        openReporteF(){
            this.$refs.refReportFeria.openmodal(this.datos);
        },
    },
    mounted() {
        this.canal = this.canales[0];
        this.getCurrentMonthDates();
        this.cargarDatos();
    },
};
</script>
